<div [ngClass]="hideBackground || back ? '' : 'journey-service'" *ngIf="navigationDetails?.length > 0" style="position: relative;">

<ng-container *ngIf="back && backButton; else next">
  <div id="resetFocus" tabindex="0"></div>

  <button *ngIf="!backButton.isHidden && showbackButton"
    dlg-button
    appCancelFocus
    id="{{ backButton.id }}"
    [theme]="backButton.theme"
    [disabled]="backButton.isDisabled"
    (click)="onButtonClick(backButton.onClick, $event)"
    class="journey-service__button-back-arrow">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.4335 12.3335L12.9002 19.8002L11.0002 21.6668L0.333496 11.0002L11.0002 0.333496L12.9002 2.20016L5.4335 9.66683H21.6668V12.3335H5.4335Z" fill="#222222"/>
    </svg>
  </button>
</ng-container>

<ng-template #next>
  <hr class="divider divider--footer">
  <div class="journey-service__container"
    [attr.data-analytics-component-name]="'Journey navigation'">
    <ng-container *ngFor="let btn of buttons">
      <button *ngIf="!btn.isHidden"
              dlg-button
              appCancelFocus
              size="toolbar"
              id="{{ btn.id }}"
              [theme]="btn.theme"
              [disabled]="btn.isDisabled"
              [class]="btn.css"
              (click)="onButtonClick(btn.onClick, $event)"
              [ngStyle]="btn.visibleOrder && {'order': btn.visibleOrder}">
        {{ btn.label }}
      </button>
    </ng-container>
  </div>
</ng-template>
</div>
